import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import MarketplaceReviewLink from '@nerdwallet/react-marketplace-review-link';
import { buildAnalyticsEntityName, buildTrkSectionCategory, sanitizeNode } from './lib/utils';
import { MORE_DETAILS, TRK_PRODUCT_LOCATION } from './lib/constants';
import styles from './marketplace-product-card.module.less';

var TabContent = function TabContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      marketplaceEntity = _ref.marketplaceEntity,
      hasReviewLink = _ref.hasReviewLink,
      reviewLinkHref = _ref.reviewLinkHref,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkSectionCategory = _ref.trkSectionCategory;

  if (!children) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, sanitizeNode(children), hasReviewLink && /*#__PURE__*/React.createElement(MarketplaceReviewLink, {
    className: styles.tabContent_reviewLink,
    marketplaceEntity: marketplaceEntity,
    href: reviewLinkHref,
    text: "Read full review",
    trkLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'tabs'),
    trkTaxonomy: taxonomy
  }));
};

TabContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  marketplaceEntity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  hasReviewLink: PropTypes.bool,
  reviewLinkHref: PropTypes.string,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkPageType: PropTypes.string,
  trkSectionCategory: PropTypes.string
};
export var TabContentImpression = function TabContentImpression(_ref2) {
  var analytics = _ref2.analytics,
      children = _ref2.children,
      className = _ref2.className,
      enableAnalytics = _ref2.enableAnalytics,
      marketplaceEntity = _ref2.marketplaceEntity,
      hasReviewLink = _ref2.hasReviewLink,
      reviewLinkHref = _ref2.reviewLinkHref,
      taxonomy = _ref2.taxonomy,
      tabId = _ref2.tabId,
      trkPageType = _ref2.trkPageType,
      trkSectionCategory = _ref2.trkSectionCategory;
  var impressionContext = useContext(ImpressionContext);

  if (!children) {
    return null;
  }

  var payload = analytics.payload;
  var elementName = buildAnalyticsEntityName("".concat(MORE_DETAILS, "_content_").concat(tabId));
  var entityName = buildAnalyticsEntityName(analytics === null || analytics === void 0 ? void 0 : analytics.entityName);
  var impressionPayload = {
    section_name: buildAnalyticsEntityName(_get(payload, 'section_name', MORE_DETAILS)),
    section_position: _get(payload, 'section_position', 1)
  };

  if (impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId) {
    impressionPayload.parent_impression_id = impressionContext.impressionId;
  }

  var enabled = !_isEmpty(analytics) || enableAnalytics;

  if (enabled) {
    return /*#__PURE__*/React.createElement(Impression, {
      entityName: (analytics === null || analytics === void 0 ? void 0 : analytics.entityName) ? entityName : elementName,
      eventType: (analytics === null || analytics === void 0 ? void 0 : analytics.eventType) || 'element_impression',
      payload: impressionPayload
    }, /*#__PURE__*/React.createElement(TabContent, {
      className: className,
      marketplaceEntity: marketplaceEntity,
      hasReviewLink: hasReviewLink,
      reviewLinkHref: reviewLinkHref,
      taxonomy: taxonomy,
      trkPageType: trkPageType,
      trkSectionCategory: trkSectionCategory
    }, children));
  }

  return /*#__PURE__*/React.createElement(TabContent, {
    className: className,
    marketplaceEntity: marketplaceEntity,
    hasReviewLink: hasReviewLink,
    reviewLinkHref: reviewLinkHref,
    taxonomy: taxonomy,
    trkPageType: trkPageType,
    trkSectionCategory: trkSectionCategory
  }, children);
};
TabContentImpression.propTypes = _objectSpread(_objectSpread({}, TabContent.propTypes), {}, {
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    eventType: PropTypes.string,
    payload: PropTypes.shape({
      section_name: PropTypes.string,
      section_position: PropTypes.number
    })
  }),
  enableAnalytics: PropTypes.bool,
  tabId: PropTypes.string
});
TabContentImpression.defaultProps = {
  analytics: {}
};
export default TabContent;